if (!window.bbqApparelToggleInstalled) {
 window.bbqApparelToggleInstalled = true;
 document.addEventListener('click', event => {
  const button = event.target.closest('.apparel-card__toggle');
  if (!button) return;
  const active = button.getAttribute('aria-pressed') !== 'true';
  button.setAttribute('aria-pressed', String(active));
  button.closest('.apparel-card__visual').classList.toggle('is-worn', active);
  button.closest('.apparel-card__visual').classList.toggle('is-flat', !active);
  button.textContent = active ? 'View shirt' : 'View on body';
 });
}

if (!window.bbqApparelCarouselInstalled) {
 window.bbqApparelCarouselInstalled = true;
 const setupApparelRails = () => document.querySelectorAll('.apparel-carousel__track').forEach(track => {
  if (track.dataset.railReady) return;
  track.dataset.railReady = 'true';
  const section = track.closest('.apparel-edit');
  const previous = section.querySelector('[data-apparel-step="-1"]');
  const next = section.querySelector('[data-apparel-step="1"]');
  const pagination = document.createElement('div');
  pagination.className = 'apparel-carousel__pagination';
  pagination.setAttribute('role','group');
  pagination.setAttribute('aria-label','Shirt carousel pages');
  track.after(pagination);
  let stops = [], current = 0;
  const go = index => track.scrollTo({left:stops[index],behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  const update = () => {
   current = stops.reduce((best,x,i) => Math.abs(x-track.scrollLeft)<Math.abs(stops[best]-track.scrollLeft)?i:best,0);
   previous.disabled = track.scrollLeft <= 2;
   next.disabled = track.scrollLeft >= track.scrollWidth-track.clientWidth-2;
   [...pagination.children].forEach((dot,i) => dot.setAttribute('aria-current',i===current?'true':'false'));
  };
  const layout = () => {
   const card = track.querySelector('.apparel-card');
   if (!card) return;
   const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
   const visible = Math.max(1,Math.floor((track.clientWidth+parseFloat(getComputedStyle(track).gap)+1)/step));
   const max = Math.max(0,track.scrollWidth-track.clientWidth);
   stops = [0];
   for(let x=step*visible;x<max-2;x+=step*visible) stops.push(x);
   if(max>2) stops.push(max);
   pagination.replaceChildren();
   stops.forEach((x,i) => {
    const dot=document.createElement('button');
    dot.type='button';
    dot.setAttribute('aria-label',`Go to shirt page ${i+1} of ${stops.length}`);
    dot.setAttribute('aria-controls',track.id);
    dot.addEventListener('click',()=>go(i));
    pagination.append(dot);
   });
   pagination.hidden=stops.length<2;
   update();
  };
  track.addEventListener('scroll',update,{passive:true});
  new ResizeObserver(layout).observe(track);
  previous.addEventListener('click',()=>go(Math.max(0,current-1)));
  next.addEventListener('click',()=>go(Math.min(stops.length-1,current+1)));
  layout();
 });
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',setupApparelRails);
 else setupApparelRails();
 document.addEventListener('shopify:section:load',setupApparelRails);
}
